import { Table } from '@tanstack/react-table';
import { Stack } from '../../../../../design-system/stack/stack';
import { ConfidenceScoresFilterSection } from './confidence-scores-filter-section';
import { MatchedTransactionsFilterSection } from './matched-transactions-filter-section';

type TableFiltersContentProps<TData> = {
  table: Table<TData>;
};

export const TableFiltersContent = <TData,>({ table }: TableFiltersContentProps<TData>) => {
  return (
    <Stack space={1.5} className="p-4">
      <ConfidenceScoresFilterSection table={table} />

      <MatchedTransactionsFilterSection table={table} />
    </Stack>
  );
};
